var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToastWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#182617"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1319_55347)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 10.5C18.34 10.5 10.5 18.34 10.5 28C10.5 37.66 18.34 45.5 28 45.5C37.66 45.5 45.5 37.66 45.5 28C45.5 18.34 37.66 10.5 28 10.5ZM29.75 36.75H26.25V33.25H29.75V36.75ZM29.75 29.75H26.25V19.25H29.75V29.75Z",
    fill: "#FFDD00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1319_55347"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastWarning);
export default __webpack_public_path__ + "static/media/toast-warning.bc217fc1b1b36ed620caeb1802adad4a.svg";
export { ForwardRef as ReactComponent };